// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pre-page-div {\n    width: 100%;\n    height: 1.33333rem;\n    line-height: 1.33333rem;\n    position: absolute;\n    /* position: fixed; */\n    left: 0;\n    bottom: 0;\n    background-color: #fff;\n    font-size: 0.42667rem;\n    color: #005423;\n    font-weight: bold;\n    text-align: center;\n}\n\n", ""]);
// Exports
module.exports = exports;
